import { useCallback, useSyncExternalStore } from 'react';
/**
 * Subscribes to a CSS media query via matchMedia. Returns `fallback` in
 * environments without matchMedia (SSR, jsdom) so callers can pick the
 * behavior they want when the viewport is unknown (e.g. assume desktop).
 */
export function useMediaQuery(query, fallback = false) {
    const subscribe = useCallback((onStoreChange) => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return () => { };
        }
        const mql = window.matchMedia(query);
        mql.addEventListener('change', onStoreChange);
        return () => mql.removeEventListener('change', onStoreChange);
    }, [query]);
    const getSnapshot = () => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return fallback;
        }
        return window.matchMedia(query).matches;
    };
    return useSyncExternalStore(subscribe, getSnapshot, () => fallback);
}
